import useSWR from 'swr';

import { useTheraFernClient } from 'hooks/useFern';
import { globalFetcherSettings } from 'lib/constants';
import { WhiteLabelClient } from 'services/whiteLabelApi';

/**
 * Returns the current user's white-label affiliations — WLCs where they're an org admin of the
 * configured ownerCompanyId. Empty array means "no affiliations"; used to gate the Companies nav
 * item and the `isWhiteLabelClientAdmin` route predicate.
 *
 * Pass `enabled = false` to skip the network call entirely (SWR treats `null` key as "skip").
 * Callers should gate on a cheap synchronous check (e.g. `isManager && isOrgAdmin`) since only
 * org admins can be WLC admins — workers and non-admin managers never need this data.
 */
export const useMyWhiteLabelClients = (
  enabled: boolean = true,
): { whiteLabelClients: WhiteLabelClient[]; isLoading: boolean } => {
  const { theraFernApi } = useTheraFernClient();
  const { data, isLoading } = useSWR<WhiteLabelClient[]>(
    enabled ? 'whiteLabel/listMyWhiteLabelClients' : null,
    () => theraFernApi.thera.whitelabel.whiteLabelApi.listMyWhiteLabelClients(),
    { ...globalFetcherSettings, revalidateOnFocus: false },
  );
  return { whiteLabelClients: data ?? [], isLoading };
};
